export default __webpack_public_path__ + "static/media/rightAllow.71fe9f88.svg";